export const inbox = {
  titles: {
    inbox: "Caixa de entrada",
    unifiedInbox: "Sua caixa de entrada, unificada",
  },
  subtitles: {
    manageMessages: "Gerencie as mensagens dos seus canais de reserva",
    unifiedDesc:
      "Aqui você verá todas as conversas com seus hóspedes, independentemente de eles escreverem pelo Airbnb, Booking ou outro canal.",
    subscribeHint:
      "Assine para ativar sua caixa de entrada e simplificar suas comunicações.",
    planOnly:
      "Este módulo está disponível apenas para os planos {plans}.",
  },
  states: {
    notInstalledTitle: "Módulo de mensagens não instalado",
    notInstalledDesc:
      "Instale o módulo de mensagens para conectar-se aos seus canais de reserva.",
    noChannelsTitle: "Nenhum canal conectado",
    noChannelsDesc:
      "Para usar o módulo de mensagens, pelo menos um canal deve estar conectado (Booking.com, Airbnb).",
    noAccessTitle: "Você não tem acesso ao módulo de mensagens",
  },
  actions: {
    installModule: "Instalar módulo de mensagens",
    configureChannel: "Configurar canal",
  },
  toasts: {
    connectChannelRequiredTitle: "Conexão necessária",
    connectChannelRequiredBody:
      "Conecte pelo menos um canal de reserva para instalar o módulo de mensagens.",
  },
  errors: {
    notFoundPropertyOrUser: "Propriedade ou usuário não encontrado.",
    channelConnectGeneric:
      "Erro ao conectar ao canal. Tente novamente.",
    generateTokenError: "Erro ao gerar o token",
  },
};
